<template lang="pug">
  v-card.groups-detail-dialog
    v-card-title
      h2.modal-title {{ isEditMode ? $t('perm.info.groups_editing') : $t('perm.info.groups_add') }}
    v-card-title
      .cols-x
        .cols-x__2
          v-input-r(
            :label="$t('base.group_name')"
            v-model="form.name")
    table.table
      thead.table__header
        tr.table__row.table__row--head
          th.table__cell {{ 'base.section' | translate }}
          th.table__cell {{ 'base.view' | translate }}
          th.table__cell {{ 'base.adding' | translate }}
          th.table__cell {{ 'base.changing' | translate }}
          th.table__cell {{ 'base.deleting' | translate }}
          th.table__cell {{ 'base.select_all' | translate }}
    .flex
      .list
        v-tabs(
          v-if="sections.length"
          vertical
          :options="sections"
          v-model="selectedSection")
      .detail
        table.table
          v-table-body(
            :cols="3"
            :empty="filteredItems.length === 0"
            :loading="!items.length")
            detail-dialog-row-item(
              v-for="(item, index) in filteredItems"
              :row="item"
              :key="index")
    v-divider
    v-card-actions
      v-btn(
        :loading="progress"
        :disabled="!form.name.length"
        @click="onAppyClick")
        | {{ 'base.allow_perm' | translate }}
</template>

<script>
import api from '@/api'

import DetailDialogRowItem from './DetailDialogRowItem.vue'

export default {
  name: 'DetailDialog',

  components: {
    DetailDialogRowItem
  },

  props: {
    selected: {
      type: Object,
      default: null
    },
    settings: {
      type: Array,
      default: () => []
    }
  },

  async mounted () {
    this.initSettings()
    if (this.isEditMode) {
      this.initDetail()
    }
  },

  data: () => ({
    sections: [
      { id: 0, name: 'sidebar.animalfeed_schedule', key: 'animalfeed_schedule' },
      { id: 1, name: 'sidebar.history', key: 'history' },
      { id: 2, name: 'perm.manager.manager', key: 'manager' },
      { id: 3, name: 'sidebar.schedule', key: 'schedule' },
      { id: 4, name: 'sidebar.reports', key: 'report' },
      { id: 5, name: 'sidebar.monitoring', key: 'monitoring' },
    ],
    selectedSection: null,
    items: [],
    form: {
      name: ''
    },
    progress: false
  }),

  methods: {
    initSettings () {
      this.items = this.settings.map((item) => ({
        ...item,
        v_view: false,
        v_add: false,
        v_change: false,
        v_delete: false
      }))
      this.selectedSection = this.sections[0]
    },

    initDetail () {
      if (this.selected) {
        this.form.name = this.selected.name
        for (const item of this.selected.settings) {
          for (const elem of this.items) {
            if (item.id === elem.id) {
              elem.v_view = item.view
              elem.v_add = item.add
              elem.v_change = item.change
              elem.v_delete = item.delete
            }
          }
        }
      }
    },

    async onAppyClick () {
      const settings = this.getSettings()
      const payload = {
        name: this.form.name,
        settings: settings
      }
      const { errors } = this.isEditMode
        ? await api.permissions.updateById(this.selected.id, payload)
        : await api.permissions.create(payload)
      errors
        ? this.$toasted.error(this.$t('errors.unexpected'))
        : this.$emit('update') && this.$emit('close')
    },

    getSettings () {
      const settings = []
      for (const item of this.items) {
        if (item.v_view || item.v_add || item.v_change || item.v_delete) {
          const data = {
            id: item.id,
            label: item.label,
            name: item.name,
            view: item.v_view,
            add: item.v_add,
            change: item.v_change,
            delete: item.v_delete
          }
          settings.push(data)
        }
      }
      return settings
    }
  },

  computed: {
    isEditMode () {
      return this.selected !== null
    },

    filteredItems () {
      return this.items.filter((item) => {
        return item.label === this.selectedSection.key
      })
    }
  }
}
</script>

<style scoped>
.v-card__title:first-child {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__title:nth-child(2) {
  border-top: .1rem solid #d7d7d7;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

</style>

<style lang="scss" scoped>
.table__header {
  .table__cell {
    font-size: 1.3rem;
    font-weight: 300;
    padding: 1.4rem 1rem;
  }

  .table__cell {
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4),
    &:nth-child(5),
    &:nth-child(6) {
      width: 10rem;
    }
  }

  .table__cell:first-child {
    padding-left: 2.7rem;
  }

  .table__cell:last-child {
    padding-right: 1.4rem;
  }
}

.list {
  width: 18rem;
  padding-right: 2rem;
  padding-left: 2rem;
}

.detail {
  width: calc(100% - 18rem);
}
</style>

<style lang="scss">
.groups-detail-dialog {
  min-height: 840px;
      display: flex;
    flex-direction: column;
    .flex {
      flex: 1;
    }
  .table__body .table__cell {
    padding: 1.4rem 1rem;

    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4),
    &:nth-child(5),
    &:nth-child(6) {
      width: 10rem;
    }
  }
}
</style>
